import { Stack } from 'expo-router'

export default function PreviewLayout() {
  return <Stack screenOptions={{ headerShown: false }} />
}
